import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import {Button, Card, Col, Row} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight, faHistory, faSave} from "@fortawesome/free-solid-svg-icons";
import {getUser} from "../../utils/StorageUtil";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import AssemblyHistoryModal from "../AssemblyHistoryModal";
import SaveAssemblyConfirmationModal from "../SaveAssemblyConfirmationModal";
import {ON_PROGRESS} from "enqc-utilities/src/utils/Global";

export default class AssemblyFormBasicInformationCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly, formStep} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        let assemblyStatusesForConfirmation = []
        this.setState({
            assembly,
            saveAssemblyConfirmationModal:false,
            assemblyHistoryCount:0,
            assemblyHistoryModal:false,
            formStep,
            assemblyStatusesForConfirmation,
            newAssemblyStatusSubmission:{}
        })
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let existingAssembly = this.state.assembly?this.state.assembly:{}
            let {assembly, formStep} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({
                assembly,
                assemblyHistoryModal:false,
                formStep,
                newAssemblyStatusSubmission:{}
            }, async () => {
                if(existingAssembly.id!=assembly.id) {
                    await this.fetchAssemblyHistoryCount()
                    await this.fetchAssemblyStatusSubmissionConfirmationList()
                }
            })
        }
    }

    confirmSubmission(){
        this.setState({saveAssemblyConfirmationModal:true})

    }

    async fetchAssemblyHistoryCount(){
        let {assembly} = this.state
        if(assembly.id) {
            let response = await this.asyncGet(Endpoint.API.ASSEMBLY_HISTORY_COUNT, {
                params: {
                    reference: assembly.reference
                }
            }, null, false, true)
            if (response.code === 200) {
                let assemblyHistoryCount = response.data
                this.setState({
                    assemblyHistoryCount,
                })
            }
        }
    }

    async fetchAssemblyStatusSubmissionConfirmationList(){
        let {assembly, assemblyStatusesForConfirmation} = this.state
        if(assembly.id) {
            let response = await this.asyncGet(Endpoint.API.ASSEMBLY_STATUSES_CONFIRMATION_SUBMISSION_LIST, {}, null, false, true)
            if (response.code === 200) {
                let assemblyStatusesForConfirmation = response.data
                this.setState({
                    assemblyStatusesForConfirmation,
                })
            }

        }
    }


    render() {
        let user = getUser()
        let {nextPage, previousPage, submitUpdate} = this.props
        let {assembly, saveAssemblyConfirmationModal, assemblyHistoryCount, assemblyHistoryModal, formStep, assemblyStatusesForConfirmation, newAssemblyStatusSubmission} = this.state
        if(isEmpty(assembly)){
            assembly = {}
        }
        let model = assembly.model?assembly.model:{}
        let assemblyStatus = assembly.assemblyStatus
        if(isEmpty(assemblyStatus)){
            assemblyStatus = {}
        }
        let lastUser = assemblyStatus.user?assemblyStatus.user:{}
        let previousButtonDisable = formStep===1
        let nextButtonDisable = formStep===3
        if(!submitUpdate){
            submitUpdate = () => {}
        }
        return (
            <Row>
                <SaveAssemblyConfirmationModal
                    postProcessingRef={this.props.postProcessingRef}
                    assemblyStatusesForConfirmation={assemblyStatusesForConfirmation}
                    show={saveAssemblyConfirmationModal}
                    model={model}
                    assembly={assembly}
                    reference={assembly.reference}
                    onClose={() => {
                        this.setState({saveAssemblyConfirmationModal:false})
                    }}
                    onResult={(selectedAssemblyStatus) => {
                        this.setState({saveAssemblyConfirmationModal:false, newAssemblyStatusSubmission:selectedAssemblyStatus}, () => {
                            submitUpdate(selectedAssemblyStatus)
                            // console.log(JSON.stringify(assembly))
                            // navigate(this.props, AssemblyFormControlPage.ENDPOINT+"?reference="+assembly.reference)
                        })
                    }}/>
                <AssemblyHistoryModal
                    show={assemblyHistoryModal}
                    assembly={assembly}
                    onClose={()=>{
                        this.setState({assemblyHistoryModal:false, selectedAssembly:{}})
                    }}/>

                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <span>{label.Reference}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <span><h2 className="text-info">{assembly.reference?assembly.reference:0}</h2></span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <span>{label.History}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center d-inline-flex align-content-center align-items-center justify-content-center">
                                    <span>
                                        <h2 className="text-info">{assemblyHistoryCount}</h2>
                                    </span>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        className="fw-normal font-small mb-2"
                                        onClick={event => {
                                            this.setState({assemblyHistoryModal:true})
                                        }}>
                                        <FontAwesomeIcon icon={faHistory} />
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={2} xs={0}>

                </Col>
                <Col lg={4} xs={12}>
                    <Card className="card-equal-height bg-transparent shadow-none mb-2 border-0">
                        <Card.Body className="bg-transparent">
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <Button
                                        id="submit-button"
                                        variant="white"
                                        disabled={!assembly.id || assemblyStatus.id != ON_PROGRESS}
                                        className={"d-block w-100 btn-outline-danger"}
                                        onClick={(event) => {
                                            event.preventDefault()
                                            this.confirmSubmission()
                                        }}>
                                        {label.Submit}
                                        &nbsp;
                                        <FontAwesomeIcon icon={faSave} size="sm" />
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mb-1">
                                <Col className="text-center">
                                    <Button
                                        id="previous-button"
                                        variant="white"
                                        className={"d-block w-100 "+(previousButtonDisable?"btn-outline-gray":"btn-outline-warning")}
                                        disabled={previousButtonDisable || !assembly.id}
                                        onClick={(event) => {
                                            event.preventDefault()
                                            previousPage()
                                        }}>
                                        <FontAwesomeIcon icon={faArrowLeft} size="sm" />
                                        &nbsp;
                                        {label.Previous}
                                    </Button>
                                </Col>
                                <Col className="text-center">
                                    <Button
                                        id="next-button"
                                        variant="white"
                                        className={"d-block w-100 "+(nextButtonDisable?"btn-outline-gray":"btn-outline-info")}
                                        disabled={nextButtonDisable || !assembly.id}
                                        onClick={(event) => {
                                            event.preventDefault()
                                            nextPage()
                                        }}>
                                        {label.Next}
                                        &nbsp;
                                        <FontAwesomeIcon icon={faArrowRight} size="sm" />
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }

}

AssemblyFormBasicInformationCard.propTypes = {
    assembly : PropTypes.any,
    nextPage : PropTypes.func,
    previousPage : PropTypes.func,
    formStep : PropTypes.number,
    submitUpdate:PropTypes.func
}